module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/time/time.component.html
// module id = ./src/app/modules/time/time.component.html
// module chunks = main